module.exports = __webpack_public_path__ + "img/img_hezuo_9@2x.1371d410.png";